import { Link } from "react-router-dom";
// material-ui
import Logo from "../../../assets/images/Gramin_Shakti_Logo.svg";
// project imports

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = ({ type }) => (
  <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
    <Link to={type === "Admin" ? "dashboard" : "#"} style={{ display: "flex", alignItems: "center", textDecoration: "none" }}>
      <img
        src={Logo}
        alt="GraminShakti Logo"
        style={{
          height: "82px",
          width: "auto",
          maxWidth: "100%",
          objectFit: "contain",
          display: "block",
        }}
      />
    </Link>
  </div>
);

export default LogoSection;
